export const sidebarWidth = "220px";
export const collapsedDesktop = "70px";
export const collapsedMobile = "0px";
export const placement = "left";
export const entityName = "sidebar-status";
